export const uiActionTypes = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',
  SHOW_UNIT_VIEW: 'SHOW_UNIT_VIEW',
  EXIT_UNIT_VIEW: 'EXIT_UNIT_VIEW',
  SET_IS_LOADING_OPTIONS: 'SET_IS_LOADING_OPTIONS',
  SET_DAYLIGHT_HOVER_VALUE: 'SET_DAYLIGHT_HOVER_VALUE',
};
